/**
 * Calculates the date range for the week containing the given start and end dates.
 * If the end date is a Sunday, the range includes only the current week; otherwise, it includes the next week.
 * Additionally, to ensure completeness, the function considers an extra week before and after the calculated week range.
 * @param {String} startDate - The start date of the range.
 * @param {String} endDate - The end date of the range.
 * @returns {Object} - An object with 'start' and 'end' properties representing the calculated date range.
 */

export function calculateWeekRange(startDate, endDate) {
    const startWeek = new Date(startDate);
    const daysUntilMonday = (startWeek.getDay() + 6) % 7;
    startWeek.setDate(startWeek.getDate() - daysUntilMonday);

    const endWeek = new Date(endDate);

    // Set to the next Sunday
    const daysUntilSunday = (7 - endWeek.getDay()) % 7;
    endWeek.setDate(endWeek.getDate() + daysUntilSunday);

    const nextEndWeek = new Date(endWeek);
    nextEndWeek.setDate(nextEndWeek.getDate() + 7);

    return {
        startWeek,
        endWeek: nextEndWeek
    };
}
